// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"06b5dd88","315":"8b388220","361":"b317a7c7","362":"439c98df","776":"8543eb0b","844":"208772d5"}[chunkId] + ".js";
};